

import VesselMonitoringBay from '@/view/pages/vesselMonitoring/components/VesselMonitoringBay/VesselMonitoringBay.vue'

export default {
  components: {
    VesselMonitoringBay
  },
  props: {
    vesselHatch: {
    },
    minDeckTiersNo:{default: 0},
    minHoldTiersNo:{default: 0},
  },
  mounted() {
  }
}
